import axios, { AxiosRequestConfig } from 'axios'

/**
 * 默认请求配置 10s超时
 */
let DEFAULT_TIMEOUT = 10000

export enum BaseURL {
  Drive = 'https://drive.wps.cn/',
  DOCS = 'https://docs.wps.cn/',
  Account = 'https://account.wps.cn/',
  OpenApi = 'https://openapi.wps.cn/',
  Plussvr = 'https://plussvr.wps.cn/',
}

export enum Method {
  Get = 'get',
  Post = 'post',
  Delete = 'delete',
  Put = 'put',
  Patch = 'patch',
}

export enum ErrorCode {
  OK = 'ok',
  ServerError = 'serverError',
  UserNotLogin = 'userNotLogin',
  PermissionDenied = 'PermissionDenied'
}

export class ResponseError {
  code: ErrorCode;
  message: string;

  constructor (code: ErrorCode, code_num: number, message: string) {
    this.code = code
    switch (code_num) {
      case 40010002:
        this.message = '企业已解散或已禁用'
        break
      case 40000104:
        this.message = '企业代码已存在'
        break
      default:
        this.message = message
    }
  }
}

function initDefConfig (request: AxiosRequestConfig) {
  request.timeout = request.timeout || DEFAULT_TIMEOUT
}

export default async function (request: AxiosRequestConfig) {
  initDefConfig(request)
  try {
    const response = await axios(request)
    return Promise.resolve(response)
  } catch (error) {
    let message = '网络异常'
    const response = error.response || {}
    const result = (response.data && response.data.result) || ErrorCode.ServerError
    let code_num
    if (response.data) {
      if (response.data.message) {
        message = response.data.message
      } else if (response.data.msg) {
        message = response.data.msg
      }
      code_num = response.data.code
    }
    return Promise.reject(new ResponseError(result, code_num, message))
  }
}
